import { TRACK_EVENT } from '../ApolloClient';
import graphqlClient from '../ApolloClient/ApolloClient';
import {
  DueDateRecordEvent,
  FeatureExposedEvent,
  PathRecommendationViewedEvent,
  PaymentMethodEvent,
  QuestionAnsweredEvent,
  ReferFriendInitiatedEvent,
  SurveyFinishedEvent,
  SurveyStartedEvent,
  WebViewEvent,
} from './models';
import { EVENT, sanitizeObject } from './utils';

const track = (eventName: string, eventData: object, traits: object = {}) => {
  if (window.analytics) {
    window.analytics.track(eventName, sanitizeObject(eventData), {
      traits: sanitizeObject(traits),
    });
  }
};

const screenTrack = (eventData: object) => {
  if (window.analytics) {
    window.analytics.page(sanitizeObject(eventData));
  }
};

export const trackQuestionAnswered = (event: QuestionAnsweredEvent, traits: object = {}) => {
  track(EVENT.QUESTION_ANSWERED, event, traits);
};

export const trackReferFriendInitiatedEvent = (event: ReferFriendInitiatedEvent) => {
  track(EVENT.REFER_FRIEND_INITIATED, event);
};

export const trackWebViewedEvent = (event: WebViewEvent) => {
  screenTrack(event);
};

export const paymentMethodEvent = (event: PaymentMethodEvent) => {
  track(EVENT.PAYMENT_METHOD_SELECTED, event);
};

export const featureExposedEvent = (event: FeatureExposedEvent) => {
  track(EVENT.FEATURE_EXPOSED, event);
};

export const trackQuestionAnsweredEvent = (event: QuestionAnsweredEvent, traits: object = {}) => {
  track(EVENT.QUESTION_ANSWERED, event, traits);
};

export const trackSurveyStartedEvent = (event: SurveyStartedEvent) => {
  track(EVENT.SURVEY_STARTED, event);
};

export const trackSurveyFinishedEvent = (event: SurveyFinishedEvent) => {
  track(EVENT.SURVEY_FINISHED, event);
};

export const trackPathRecommendationViewedEvent = (event: PathRecommendationViewedEvent) => {
  track(EVENT.PATH_RECOMMENDATION_VIEWED, event);
};

export const trackLegacyEvent = (eventName: string, properties: string) => {
  graphqlClient.mutate({
    mutation: TRACK_EVENT,
    variables: { eventName, properties },
    fetchPolicy: 'no-cache',
  });
};

export const trackDueDateRecordedEvent = (event: DueDateRecordEvent, traits: object = {}) => {
  track(EVENT.DUE_DATE_RECORDED, event, traits);
};
